import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import './CarouselStyles.css';
import axios from 'axios';
import { ApiStorage, ApiUrl } from '../../../services/ApiRest';




export const SearchBeneffit = () => {
    const scrollRef = useRef(null);
    const [aliados, setaliados] = useState([])

    const [answer, setanswer] = useState('')

    const [ci, setci] = useState(null);

    const scroll = (direction) => {
        const container = scrollRef.current;
        const scrollAmount = container.offsetWidth * 0.1;
        container.scrollBy({ left: direction === 'left' ? -scrollAmount : scrollAmount, behavior: 'smooth' });
    };

    const searchClient = async (event) => {
        event.preventDefault();
        // alert(ci);
        await axios.get(ApiUrl + "consult-apply-benefit/" + ci)
            .then(response => {
                const data = response.data;
                // setaliados(data);
                setanswer(data.message)
                setaliados(data.data)
                console.log(data);


                //cargamos los datos nuevos
                const script = document.createElement("script");
                script.src = `/assets/dataTable/dataTable.js`;
                script.async = true;
                document.body.appendChild(script);
            })
            .catch(e => {
                console.log(e)
            })

    }

    const onInputChange = ({ target }) => {
        setci(target.value);
    }



    return (
        <>
            <div className="card">
                <h5 className="card-header camping-letters">Consulta si aplicas al Beneficio</h5>
                <div className="card-body">

                    <form onSubmit={searchClient}>
                        <div className="mb-3">
                            <label for="exampleInputEmail1" className="form-label">Ingrese CI</label>
                            <input type="text" className="form-control" onChange={onInputChange}></input>
                            {/* <div id="emailHelp" className="form-text">We'll never share your email with anyone else.</div> */}
                        </div>
                        <button type="submit" className="btn btn-primary">Consultar</button>
                    </form>

                    {
                        (answer === 'Aplica Beneficio') ?
                            <div className="alert alert-success" role="alert" style={{ marginTop: "2vh" }}>
                                <p>Felicidades disfruta tus beneficios desde: </p>
                                <p>{aliados.init} al {aliados.end}</p>
                            </div>

                            : (answer === 'Aplica Fecha Futura') ?
                                <div className="alert alert-warning" role="alert" style={{ marginTop: "2vh" }}>
                                    <p>Pronto podras canjear tus beneficios.<br></br>
                                        <br></br>Tus beneficios estarán disponibles del: {aliados.init} al {aliados.end}
                                    </p>
                                </div>
                                :
                                (answer === 'No aplica') ?
                                    <div className="alert alert-danger" role="alert" style={{ marginTop: "2vh" }}>
                                        <p>Lo sentimos! No accedes a los beneficios</p>
                                    </div>
                                    :
                                    (answer === 'No aplica fecha pasada') ?
                                        <div className="alert alert-danger" role="alert" style={{ marginTop: "2vh" }}>
                                            <p>Lo sentimos! No accedes a los beneficios.
                                                <br></br>Tus beneficios estuvieron disponibles del: {aliados.init} al {aliados.end}</p>
                                            <p></p>
                                        </div>
                                        :
                                        <p></p>

                    }
                </div>
            </div>

        </>


    );
};
